import { del, get, post, put, request, upload } from './http'

const query = (params = {}) => {
  const values = new URLSearchParams()
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== '' && value !== undefined && value !== null) values.set(key, value)
  })
  const text = values.toString()
  return text ? `?${text}` : ''
}

export const webApi = {
  memberApplicationState: (id, key = '', language = '') => get(`/v1/web/activityApplication/${encodeURIComponent(id)}/state${query({key,language})}`),
  memberApplicationSubmit: (id, data) => post(`/v1/web/activityApplication/${encodeURIComponent(id)}/apply`, data),
  memberApplicationRecords: data => post('/v1/web/activityApplication/record/page', data),
  // 站点内容
  bootstrap: () => get('/v1/web/content/bootstrap'),
  promotionListPage: () => get('/v1/web/content/promotion/list/page'),
  banners: () => get('/v1/web/content/banner/list'),
  notices: () => get('/v1/web/content/notice/list'),
  helpCategories: (siteType = 1) => get(`/v1/web/content/help/category/list${query({ siteType })}`),
  helpArticles: (data) => post('/v1/web/content/help/article/page', data),
  helpArticleDetail: (id, siteType = 1) => get(`/v1/web/content/help/article/${id}${query({ siteType })}`),
  sponsors: () => get('/v1/web/contentExtension/sponsor/list'),
  sponsorDetail: (id) => get(`/v1/web/contentExtension/sponsor/${id}`),
  contentPage: (data) => post('/v1/web/contentExtension/page', data),
  footer: (params) => get(`/v1/web/pcFooter/list${query(params)}`),
  floatingAdvertisements: () => get('/v1/web/content/advertisement/float/list'),
  memberAdvertisements: (params) => get(`/v1/web/member/advertisement${query(params)}`),
  appConfig: () => get('/v1/web/contentExtension/appConfig'),

  // 登录认证
  captcha: () => get('/v1/web/auth/captcha'),
  login: (data) => post('/v1/web/auth/login', data),
  register: (data) => post('/v1/web/auth/register', data),
  sendVerificationCode: (data) => post('/v1/web/auth/verificationCode/send', data),
  resetPassword: (data) => post('/v1/web/auth/password/reset', data),

  // 会员中心
  memberDashboard: () => get('/v1/web/member/dashboard'),
  memberProfile: () => get('/v1/web/member/profile'),
  updateMemberProfile: (data) => put('/v1/web/member/profile', data),
  logout: () => post('/v1/web/member/logout'),
  memberKyc: () => get('/v1/web/member/kyc'),
  uploadKycImage: (formData) => upload('/v1/web/member/kyc/image', formData),
  submitMemberKyc: (data) => post('/v1/web/member/kyc', data),
  verifyPhoneThreeFactor: (data) => post('/v1/web/member/threeFactor/verify', data),
  paymentAccountOptions: () => get('/v1/web/member/paymentAccount/options'),
  paymentAccounts: (params) => get(`/v1/web/member/paymentAccount/list${query(params)}`),
  createPaymentAccount: (data) => post('/v1/web/member/paymentAccount', data),
  updatePaymentAccount: (id, data) => put(`/v1/web/member/paymentAccount/${id}`, data),
  paymentAccountDetail: (id) => get(`/v1/web/member/paymentAccount/${id}`),
  deletePaymentAccount: (id) => del(`/v1/web/member/paymentAccount/${id}`),

  // 账户安全
  securityStatus: () => get('/v1/web/security/status'),
  modifyLoginPassword: (data) => put('/v1/web/security/loginPassword', data),
  setPaymentPassword: (data) => put('/v1/web/security/paymentPassword', data),
  bindContact: (data) => put('/v1/web/security/contact', data),
  updateAvatar: (data) => put('/v1/web/security/avatar', data),
  uploadAvatarImage: (formData) => upload('/v1/web/security/avatar/image', formData),

  // 游戏与赛事
  venues: () => get('/v1/web/game/venue/list'),
  games: (data) => post('/v1/web/game/page', data),
  // 后端游戏启动包含玩家、钱包和供应商调用，等待时间须覆盖其35秒处理窗口。
  launchGame: (venueId, gameId) => post(`/v1/web/game/venue/${venueId}/launch`, { id: venueId, gameId }, { timeoutMs: 40000 }),
  betOrders: (data) => post('/v1/web/game/bet/page', data),
  betOrderDetail: (id) => get(`/v1/web/game/bet/${id}`),
  gameDiscovery: () => get('/v1/web/gameExtension/discovery'),
  favoriteGames: (data) => post('/v1/web/gameExtension/favorite/page', data),
  addFavorite: (gameId) => post('/v1/web/gameExtension/favorite', { gameId }),
  removeFavorite: (gameId) => del(`/v1/web/gameExtension/favorite/${gameId}`),
  liveEvents: (data) => post('/v1/web/gameExtension/liveEvent/page', data),
  liveEventDetail: (id) => get(`/v1/web/gameExtension/liveEvent/${id}`),
  venueWallets: () => get('/v1/web/gameWallet/list'),
  transferVenueWallet: (data) => post('/v1/web/gameWallet/transfer', data),
  recycleVenueWallets: () => post('/v1/web/gameWallet/recycle'),
  autoTransfer: () => get('/v1/web/gameWallet/autoTransfer'),
  setAutoTransfer: (data) => put('/v1/web/gameWallet/autoTransfer', data),

  // 活动与优惠
  activityCategories: () => get('/v1/web/activity/category/list'),
  activities: async (params) => (await get(`/v1/web/activity/list${query(params)}`) || []),
  activityPage: (data) => post('/v1/web/activity/page', data),
  recordActivityVisit: (id, data) => post(`/v1/web/activity/${id}/visit`, data),
  activityDetail: (id, language = '') => get(`/v1/web/activity/${id}${query({language})}`),
  claimActivity: (id, data = {}) => post(`/v1/web/activity/${id}/claim`, data),
  gameplayState: (id) => get(`/v1/web/activityGameplay/${id}/state`),
  pageBackflowState: id => get(`/v1/web/activityGameplay/${encodeURIComponent(id)}/pageBackflow`),
  pageBackflowClaim: (id, body) => post(`/v1/web/activityGameplay/${encodeURIComponent(id)}/pageBackflow`, body),
  euroTopState: id => get(`/v1/web/activityGameplay/${encodeURIComponent(id)}/euroTop`),
  euroTopClaim: (id, body) => post(`/v1/web/activityGameplay/${encodeURIComponent(id)}/euroTop`, body),
  euroQuizState: (id) => get(`/v1/web/activityGameplay/${encodeURIComponent(id)}/euroQuiz`),
  euroQuizAction: (id, data) => post(`/v1/web/activityGameplay/${encodeURIComponent(id)}/euroQuiz`, data),
  gameplayAction: (id, data) => post(`/v1/web/activityGameplay/${id}/action`, data),
  gameplayRequest: (id, requestId) => get(`/v1/web/activityGameplay/${id}/request/${requestId}`),
  voteRecords: (id, data) => post(`/v1/web/activityGameplay/${id}/votePage`, data),
  voteResult: (id, requestId) => get(`/v1/web/activityGameplay/${id}/voteResult/${requestId}`),
  firstDepositState: (id, params = {}) => get(`/v1/web/activityGameplay/${id}/firstDeposit${query(params)}`),
  newbiePackage: (id) => get(`/v1/web/activityGameplay/${id}/newbiePackage`),
  firstDepositOriginal: (id) => get(`/v1/web/activityGameplay/${id}/firstDepositApplication`),
  firstDepositPreview: (id, data) => post(`/v1/web/activityGameplay/${id}/firstDepositPreview`, data),
  firstDepositApplication: (id, data) => post(`/v1/web/activityGameplay/${id}/firstDepositApplication`, data),
  firstDepositApplicationResult: (id, uuid) => get(`/v1/web/activityGameplay/${id}/firstDepositApplication/${encodeURIComponent(uuid)}`),
  activityPrizes: (id) => get(`/v1/web/prize/activity/${id}/list`),
  applyActivityPrize: (id, data) => post(`/v1/web/prize/activity/${id}/apply`, data),
  updatePrizeReceipt: (id, data) => put(`/v1/web/prize/${id}/receipt`, data),
  prizeOrders: (data) => post('/v1/web/prize/page', data),
  prizeOrder: (id) => get(`/v1/web/prize/${id}`),
  activityClaims: (data) => post('/v1/web/activity/claim/page', data),
  activityVipSummary: () => get('/v1/web/activity/vip/summary'),
  invitationSummary: (params) => get(`/v1/web/activity/invitation/summary${query(params)}`),
  worldCupTopic: () => get('/v1/web/activity/worldCup/topic'),
  signInStatus: (id, optionsOrCategory = {}, signCategory = 0) => get(`/v1/web/activityExtension/${id}/sign/status${query({ signCategory: (Number.isInteger(optionsOrCategory) ? optionsOrCategory : signCategory) || undefined })}`),
  signInVenueState: id => get(`/v1/web/activityExtension/sign/venue-reward/${encodeURIComponent(id)}`),
  claimSignInVenue: (id, venueId) => post(`/v1/web/activityExtension/sign/venue-reward/${encodeURIComponent(id)}/claim`, { venueId: String(venueId) }),
  executeActivityAction: (id, data) => post(`/v1/web/activityExtension/${id}/action`, data),
  activityRecords: (data) => post('/v1/web/activityExtension/record/page', data),
  promotionInvitationSummary: () => get('/v1/web/promotion/invitation/summary'),
  redeemCoupon: (data) => post('/v1/web/coupon/redeem', data),

  // 钱包与财务
  wallets: () => get('/v1/web/finance/wallet/list'),
  depositMethods: () => get('/v1/web/finance/deposit/method/list'),
  createDeposit: (data) => post('/v1/web/finance/deposit', data),
  depositOrders: (data) => post('/v1/web/finance/deposit/page', data),
  depositOrderDetail: (id) => get(`/v1/web/finance/deposit/${id}`),
  withdrawalMethods: () => get('/v1/web/finance/withdrawal/method/list'),
  quoteWithdrawal: (data) => post('/v1/web/finance/withdrawal/quote', data),
  createWithdrawal: (data) => post('/v1/web/finance/withdrawal', data),
  withdrawalOrders: (data) => post('/v1/web/finance/withdrawal/page', data),
  withdrawalOrderDetail: (id) => get(`/v1/web/finance/withdrawal/${id}`),
  cancelWithdrawal: (id) => post(`/v1/web/finance/withdrawal/${id}/cancel`),
  createTransfer: (data) => post('/v1/web/finance/transfer', data),
  transferOrders: (data) => post('/v1/web/finance/transfer/page', data),
  transferOrderDetail: (id) => get(`/v1/web/finance/transfer/${id}`),
  walletTransactions: (data) => post('/v1/web/finance/transaction/page', data),
  walletTransactionDetail: (id) => get(`/v1/web/finance/transaction/${id}`),
  depositExchangeRate: () => get('/v1/web/financeExtension/deposit/exchangeRate'),
  cancelDeposit: (id) => post(`/v1/web/financeExtension/deposit/${id}/cancel`),
  unfinishedDeposit: () => get('/v1/web/financeExtension/deposit/unfinished'),
  uploadDepositVoucher: (id, data) => put(`/v1/web/financeExtension/deposit/${id}/voucher`, data),
  urgeDeposit: (id) => post(`/v1/web/financeExtension/deposit/${id}/urge`),
  withdrawalQualification: () => get('/v1/web/financeExtension/withdrawal/qualification'),
  withdrawalNotices: () => get('/v1/web/financeExtension/withdrawal/notice/list'),

  // 客服与反馈
  customerDashboard: () => get('/v1/web/customerService/dashboard'),
  customerSessions: (data) => post('/v1/web/customerService/session/page', data),
  createCustomerSession: (data) => post('/v1/web/customerService/session', data),
  customerMessages: (id, data) => post(`/v1/web/customerService/session/${id}/message/page`, data),
  sendCustomerMessage: (id, data) => post(`/v1/web/customerService/session/${id}/message`, data),
  uploadFeedbackImage: (formData) => upload('/v1/web/support/feedback/image', formData),
  feedbackTypes: () => get('/v1/web/support/feedback/type/list'),
  createFeedback: (data) => post('/v1/web/support/feedback', data),
  feedbackPage: (data) => post('/v1/web/support/feedback/page', data),
  feedbackDetail: (id) => get(`/v1/web/support/feedback/${id}`),
  deleteFeedback: (id) => del(`/v1/web/support/feedback/${id}`),
  messageTypes: () => get('/v1/web/support/message/options'),
  messagePage: (data) => post('/v1/web/support/message/page', data),
  readMessage: (id) => post(`/v1/web/support/message/${id}/read`),
  readMessages: (data) => post('/v1/web/support/message/readBatch', data),
  readAllMessages: () => post('/v1/web/support/message/readAll'),
  deleteMessages: (data) => request('/v1/web/support/message/batch', { method: 'DELETE', body: data }),
  deleteReadMessages: () => del('/v1/web/support/message/read'),

  // 代理
  agentSummary: () => get('/v1/web/agent/summary'),
  agentCommissions: (data) => post('/v1/web/agent/commission/page', data),
  agentSettlements: (data) => post('/v1/web/agent/settlement/page', data),
  agentApplication: () => get('/v1/web/agentApplication/detail'),
  applyAgent: (data) => post('/v1/web/agentApplication/apply', data),

  // 返水
  rebateSummary: () => get('/v1/web/rebate/summary'),
  rebatePage: (data) => post('/v1/web/rebate/page', data),
  rebateDetail: (id) => get(`/v1/web/rebate/detail/${id}`),
  rebateRule: () => get('/v1/web/rebate/rule'),
  claimRebate: (data) => post('/v1/web/rebate/claim', data),

  // 余额宝
  balanceTreasureSummary: () => get('/v1/web/balanceTreasure/summary'),
  transferBalanceTreasure: (data) => post('/v1/web/balanceTreasure/transfer', data),
  balanceTreasureInterests: (data) => post('/v1/web/balanceTreasure/interest/page', data),
  balanceTreasureTransfers: (data) => post('/v1/web/balanceTreasure/transfer/page', data),
  balanceTreasureTasks: (data) => post('/v1/web/balanceTreasure/task/page', data),
  balanceTreasureOffers: () => get('/v1/web/balanceTreasure/task/offers'),
  joinBalanceTreasureTask: (data) => post('/v1/web/balanceTreasure/task/join', data),
  claimBalanceTreasureTask: (data) => post('/v1/web/balanceTreasure/task/claim', data),
  claimBalanceTreasureInterest: (data) => post('/v1/web/balanceTreasure/interest/claim', data),
  balanceTreasureRule: () => get('/v1/web/balanceTreasure/rule'),

  // VIP
  vipDetail: () => get('/v1/web/vip/detail'),
  vipPrivileges: () => get('/v1/web/vip/privilege/list'),
  vipBonuses: (data) => post('/v1/web/vip/bonus/page', data),
  vipPromotionRules: () => get('/v1/web/vip/promotion/rule/list'),
  claimVipPromotion: (data) => post('/v1/web/vip/promotion/claim', data),
  vipGiftRule: () => get('/v1/web/vip/gift/rule'),
  applyVipGift: (data) => post('/v1/web/vip/gift/apply', data),
  vipReceiptInfo: () => get('/v1/web/vip/receiptInfo'),
  updateVipReceiptInfo: (data) => put('/v1/web/vip/receiptInfo', data),

  // 积分
  pointsTransactions: (data) => post('/v1/web/points/transactions/page', data),
  manualBonuses: (data) => post('/v1/web/bonus/page', data),
  manualBonusDetail: (id) => get(`/v1/web/bonus/${encodeURIComponent(id)}`),
  claimManualBonus: (id) => post(`/v1/web/bonus/${encodeURIComponent(id)}/claim`),
  rainRewardState: (id) => get(`/v1/web/activityGameplay/rain-reward/${encodeURIComponent(id)}`),
  challengeRewardState: (id) => get(`/v1/web/activityGameplay/challenge-reward/${encodeURIComponent(id)}`),
  claimChallengeReward: (id, venueId) => post(`/v1/web/activityGameplay/challenge-reward/${encodeURIComponent(id)}/claim`, { venueId: String(venueId) }),
  claimRainReward: (id, venueId) => post(`/v1/web/activityGameplay/rain-reward/${encodeURIComponent(id)}/claim`, { venueId: String(venueId) }),
  pointsCenter: () => get('/v1/web/points/center'),
  pointsRewards: (data) => post('/v1/web/points/rewards/page', data),
  claimPoints: (data) => post('/v1/web/points/claim', data),

  // 综合记录与系统
  unifiedRecords: (data) => post('/v1/web/record/page', data),
  systemStatus: () => get('/v1/web/system/status'),
  systemLines: () => get('/v1/web/system/line/list'),
}

export const friendWheelApi = {
  state: (id) => get(`/v1/web/activity/${id}/wheel`),
  join: (id, data) => post(`/v1/web/activity/${id}/wheel/join`, data),
  assist: (id, data) => post(`/v1/web/activity/${id}/wheel/assist`, data),
  draw: (id, data) => post(`/v1/web/activity/${id}/wheel/draw`, data),
  tasks: (id, data) => post(`/v1/web/activity/${id}/wheel/tasks/reconcile`, data),
  withdraw: (id, data) => post(`/v1/web/activity/${id}/wheel/withdraw`, data)
};
